import useKeelLogoSwitch from "../../hooks/useKeelLogoSwitch";
import HamburgerDropdown from "../HamburgerDropdown/HamburgerDropdown";
import styles from "./HamburgerMenu.module.css";
import MindPageLink from "../MindPageLink/MindPageLink";
import { Link } from "react-router-dom";

function HamburgerMenu({
    className,
    showMenu,
    setShowMenu,
    menuRef,
    data,
    showSignIn,
}) {
    const logoSrc = useKeelLogoSwitch(false, true);

    function handleCloseClick() {
        // props.menuRef.current.classList.toggle("show");
        setShowMenu(false);
    }

    function handleEscape(event) {
        if (event.keyCode === 27) {
            setShowMenu(false);
        }
    }

    return (
        <div
            // style={{ display: "none" }}
            ref={menuRef}
            style={
                {
                    // visibility: "hidden",
                }
            }
            className={[
                styles.hamburger_menu_wrapper,
                showMenu ? styles.show : "",
                className,
            ].join(" ")}
            onKeyDown={handleEscape}
        >
            <div className={styles.cover} onClick={handleCloseClick}></div>
            <div className={styles.menu_scroll_wrapper}>
                <div className={styles.menu}>
                    <div className={styles.menu_header}>
                        <Link to="/">
                            <img
                                draggable={false}
                                id={styles.logo}
                                src={logoSrc}
                                alt={"Keel Digital Solutions logo"}
                            />
                        </Link>
                        <button
                            onClick={handleCloseClick}
                            className={styles.close_button}
                            aria-label="Close navigation menu"
                        >
                            <img
                                src="/images/modal-close-icon-thick-white.svg"
                                alt="Close navigation menu"
                            />
                        </button>
                    </div>
                    <div id={styles.links_container}>
                        {data.map((link) =>
                            link.children ? (
                                <HamburgerDropdown
                                    text={link.name}
                                    className={styles.link}
                                    key={link.name}
                                    menuState={showMenu}
                                >
                                    {link.children.map(
                                        ({ name, href, ...props }) => (
                                            <MindPageLink
                                                key={href}
                                                href={href}
                                                className={styles.link}
                                                style={{
                                                    width: "100%",
                                                }}
                                                {...props}
                                            >
                                                {name}
                                            </MindPageLink>
                                        )
                                    )}
                                </HamburgerDropdown>
                            ) : (
                                <Link
                                    key={link.name}
                                    to={link.href}
                                    className={styles.link}
                                >
                                    {link.name}
                                </Link>
                            )
                        )}
                        <div id={styles.bottom_links}>
                            {showSignIn && (
                                <HamburgerDropdown
                                    text={"Sign in"}
                                    className={styles.link}
                                    menuState={showMenu}
                                >
                                    <Link
                                        target="_blank"
                                        to={
                                            "https://app.us.geta-head.com/app/gah/"
                                        }
                                        className={styles.link}
                                    >
                                        United States
                                    </Link>
                                    <Link
                                        target="_blank"
                                        to={
                                            "https://app.ca.geta-head.com/app/gah/"
                                        }
                                        className={styles.link}
                                    >
                                        Canada
                                    </Link>
                                </HamburgerDropdown>
                            )}
                            <Link
                                to={"/contact-us"}
                                id={styles.contact_button}
                                className={[
                                    styles.link /*, "orange-button"*/,
                                ].join(" ")}
                            >
                                Contact us
                            </Link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default HamburgerMenu;
